



















import Vue from 'vue'
import { INavMenuGroup } from '@/types/data-objects/global'

export default Vue.extend({
  name: 'DdSidebar',

  props: {
    elements: {
      type: Array as () => INavMenuGroup[],
      required: true,
    },
  },

  methods: {
    goToRoute(value: string): void {
      this.$router.push({ name: value })
    },
  },
})
